import React from "react";
import { Link } from "react-router-dom";
import { ArrowLeft, ShieldCheck } from "lucide-react";
import { useNavigationHistory } from "../../contexts/NavigationHistoryContext";

const LOGO = "/brand-logo.png";

/** Shared dark-theme shell for the public /privacy and /terms pages. */
export default function LegalLayout({ title, updated, children }) {
  const { goBack } = useNavigationHistory();
  return (
    <div className="min-h-screen bg-[#0B1220] text-slate-300">
      <div className="absolute inset-0 opacity-[0.04] pointer-events-none" style={{
        backgroundImage: "radial-gradient(circle at 1px 1px, white 1px, transparent 0)",
        backgroundSize: "32px 32px",
      }} />
      <header className="relative border-b border-white/10">
        <div className="max-w-3xl mx-auto px-5 lg:px-0 py-5 flex items-center justify-between">
          <Link to="/" data-testid="legal-home-link" className="flex items-center gap-2.5">
            <div className="h-9 w-9 rounded-lg bg-white flex items-center justify-center overflow-hidden shrink-0">
              <img src={LOGO} alt="ServiceGuru Pro" className="h-full w-full object-contain" />
            </div>
            <span className="text-white font-bold text-[15px] tracking-tight">ServiceGuru Pro</span>
          </Link>
          <button type="button" onClick={() => goBack("/")} data-testid="legal-back-link" className="inline-flex items-center gap-1.5 text-[13px] text-slate-400 hover:text-white transition-colors">
            <ArrowLeft className="h-3.5 w-3.5" /> Back to home
          </button>
        </div>
      </header>

      <main className="relative max-w-3xl mx-auto px-5 lg:px-0 py-12">
        <div className="flex items-center gap-2 mb-2">
          <ShieldCheck className="h-5 w-5 text-blue-400" />
          <h1 className="text-3xl font-bold text-white tracking-tight" data-testid="legal-page-title">{title}</h1>
        </div>
        <p className="text-[13px] text-slate-500 mb-10">Last updated: {updated}</p>

        <div className="space-y-8 text-[14.5px] leading-relaxed [&_h2]:text-[19px] [&_h2]:font-bold [&_h2]:text-white [&_h2]:mb-2.5 [&_h2]:mt-1 [&_p]:mb-3 [&_p]:text-slate-300 [&_ul]:list-disc [&_ul]:pl-5 [&_ul]:space-y-1.5 [&_ul]:text-slate-300 [&_ul]:mb-3 [&_strong]:text-slate-100 [&_a]:text-blue-400 [&_a]:hover:underline">
          {children}
        </div>

        <div className="mt-14 pt-6 border-t border-white/10 flex flex-wrap items-center gap-4 text-[13px] text-slate-500">
          <Link to="/privacy" data-testid="legal-nav-privacy" className="hover:text-white transition-colors">Privacy Policy</Link>
          <span className="text-slate-700">·</span>
          <Link to="/terms" data-testid="legal-nav-terms" className="hover:text-white transition-colors">Terms of Service</Link>
          <span className="text-slate-700">·</span>
          <a href="mailto:info@servicegurupro.com" className="hover:text-white transition-colors">info@servicegurupro.com</a>
        </div>
      </main>
    </div>
  );
}
